export default __webpack_public_path__ + "assets/images/e8602b08f40ed1da1697209a76b0c563-mgm-link-icon.svg";